module.exports = {
      id: "shortvideo-usage",
      viewBox: "0 0 15 19",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#shortvideo",
      toString: function () {
        return this.url;
      }
    }